import { MANUAL_READINGS_ENABLED, RIVER_ENABLED } from '@/constants/features'

const adminChildren = [
  {
    name: 'User Management',
    url: '/settings/admin',
    icon: 'fa-users-cog'
  },
  {
    name: 'Team Management',
    url: '/settings/teams',
    icon: 'fa-users'
  },
  {
    name: 'Site Management',
    url: '/settings/sites',
    icon: 'fa-map-marker-alt'
  }
]

if (MANUAL_READINGS_ENABLED) {
  adminChildren.push(
    {
      name: 'Manual Readings',
      url: '/settings/manual-readings',
      icon: 'fa-pencil-ruler'
    },
    {
      name: 'Historical Import',
      url: '/settings/historical-import',
      icon: 'fa-file-import'
    }
  )
}

adminChildren.push(
  {
    name: 'Maintenance',
    url: '/settings/maintenance',
    icon: 'fa-wrench'
  },
  {
    name: 'Audit Log',
    url: '/settings/audit-log',
    icon: 'fa-history'
  }
)

export default {
  items: [
    // {
    //   name: 'Dashboard',
    //   url: '/dashboard',
    //   icon: 'fa-home'
    // },
    {
      title: true,
      name: 'Sensor Data'
    },
    {
      name: 'Plunge Pools',
      url: '/sensor-data/plunge',
      icon: 'fa-leaf'
    },
    {
      name: 'Flumes',
      url: '/sensor-data/flume',
      icon: 'fa-chart-area'
    },
    {
      name: 'Wells',
      url: '/sensor-data/well',
      icon: 'fa-tint',
      enabled: true
    },
    {
      name: 'Bubblers',
      url: '/sensor-data/bubbler',
      icon: 'fa-ellipsis-v',
      enabled: true
    },
    {
      name: 'Rivers',
      url: '/sensor-data/river',
      icon: 'fa-stream',
      enabled: RIVER_ENABLED
    },
    {
      name: 'Rain Gauges',
      url: '/sensor-data/rain',
      icon: 'fa-tint',
      enabled: false
    },
    {
      name: 'Monitor Wells',
      url: '/sensor-data/well',
      icon: 'fa-database',
      enabled: false
    },
    {
      title: true,
      name: 'Metadata',
      enabled: false
    },
    {
      name: 'Sites',
      url: '/sites',
      icon: 'fa-map',
      enabled: false
    },
    {
      name: 'Locations',
      url: '/locations',
      icon: 'fa-map-marker-alt',
      enabled: false
    },
    {
      name: 'Devices',
      url: '/devices',
      icon: 'fa-wifi',
      enabled: false
    },
    {
      title: true,
      name: 'Alerting'
    },
    {
      name: 'Rules & Notifications',
      icon: 'fa-exclamation-triangle',
      children: [
        {
          name: 'View / Modify Rules',
          url: '/rules',
          icon: 'fa-cog'
        },
        {
          name: 'Create Rule',
          url: '/create-rule',
          icon: 'fa-edit'
        },
        {
          name: 'Notification Targets',
          url: '/targets',
          icon: 'fa-comment'
        }
      ]
    },
    {
      name: 'Device Health',
      url: '/device-health',
      icon: 'fa-heartbeat'
    },
    {
      title: true,
      name: 'Settings'
    },
    {
      name: 'Account',
      icon: 'fa-user',
      children: [
        {
          name: 'Profile',
          url: '/account/profile',
          icon: 'fa-user-edit',
          enabled: true
        },
        {
          name: 'Billing',
          url: '/account/billing',
          icon: 'fa-dollar-sign',
          enabled: false
        },
        {
          name: 'Logout',
          method: 'logout',
          icon: 'fa-power-off'
        }
      ]
    },
    {
      name: 'Device Configuration',
      url: '/settings/devices',
      icon: 'fa-microchip',
      enabled: true,
      requiresRole: 'ADMIN'
    },
    {
      name: 'Admin',
      icon: 'fa-shield-alt',
      requiresRole: 'ADMIN',
      children: adminChildren
    },
    {
      name: 'About',
      url: '/about',
      icon: 'fa-info-circle'
    },
    {
      name: 'leaf.ai',
      url: 'https://leaf.ai',
      icon: 'fa-home',
      class: 'mt-auto nav-brand',
      variant: 'success'
    }
  ]
}
